import { render, staticRenderFns } from "./cmodel.vue?vue&type=template&id=4350c1a9"
import script from "./cmodel.vue?vue&type=script&lang=js"
export * from "./cmodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports